/* eslint no-unused-vars: "off" */
import Immutable from 'immutable';
import axios from './api';
import qs from 'qs';
import { getEnvDetail } from '../utils/env';

const envDetail = getEnvDetail();
const PLATFORM = envDetail.apiUrl;

let token;
const setToken = ({ value }) => {
  token = value;
};

const getResponseType = route => {
  if (route.includes('job/GetUploadJobFileByFileId') || route.includes('eightdprocess/ContainmentActionFile')) {
    return 'arraybuffer';
  }
  if (route.includes('/batches/') && route.includes('/download')) {
    return 'blob';
  }
  return '';
};

const call = ({ method, route, data, params, api }) => {
  if (!api) api = PLATFORM;
  const responseType = getResponseType(route);
  const operation = axios.request({
    baseURL: api,
    url: route,
    method,
    data,
    params,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' }),
    responseType: responseType,
  });

  return new Promise((resolve, reject) => {
    operation
      .then(resp => {
        if (resp.status >= 200 && resp.status < 300) {
          // Response was good! Let's parse it and resolve

          // For blob/arraybuffer responses, return data directly without Immutable conversion
          if (responseType === 'blob' || responseType === 'arraybuffer') {
            return resolve({ data: resp.data });
          }

          if (!resp.data) return resolve({ data: resp.data });

          const immutableJson = Immutable.fromJS(resp.data);
          const _data = immutableJson.get ? immutableJson.get('data') : immutableJson;
          if (_data) return resolve({ data: _data, meta: immutableJson?.get?.('meta') });

          return resolve({ data: immutableJson, id: resp.data?.id });
        }

        // Response was bad, let's throw an error
        const error = new Error('THINGTRAX API Error!');
        error.details = Immutable.fromJS(resp.data);

        return reject(error);
      })
      .catch(err => {
        console.log(err, 'err');
        const error = new Error('Error while fetching from THINGTRAX API');
        error.details = err;
        error.exceptionContent = err?.response?.data;
        return reject(error);
      });
  });
};

const post = ({ route, api, params, data }) => {
  return call({ method: 'POST', route, api, params, data });
};
const put = ({ route, api, params, data }) => {
  console.log('Printing data in put request in tt api: ', data);
  return call({ method: 'PUT', route, api, params, data });
};

const get = ({ route, api, params }) => {
  return call({ method: 'GET', route, api, params });
};

const patch = ({ route, api, params, data }) => {
  return call({ method: 'PATCH', route, api, params, data });
};

const _delete = ({ route, api, params, data }) => {
  return call({ method: 'DELETE', route, api, params, data });
};

export default {
  call,
  post,
  put,
  get,
  patch,
  delete: _delete,
  setToken,
  PLATFORM,
};
